import React from "react";
import { Button } from "react-bootstrap";

const conditionTemplates = {
  new: "Condition: New\n\nItem is brand new, unused, and in original packaging. All original accessories and materials are included unless otherwise noted.",
  
  likeNew: "Condition: Like New\n\nItem is in near-new condition with little to no signs of use. Fully tested and includes original packaging and accessories when available.",
  
  used: "Condition: Used\n\nItem shows light to moderate signs of wear from normal use but remains fully functional. Tested and guaranteed to work properly.",
  
  newWithTags: "Condition: New with Tags\n\nItem is brand new and has never been used. Original tags are still attached.",
  
  forParts: "Condition: For Parts or Not Working\n\nItem does not function as intended or may be incomplete. Sold AS-IS with no guarantees, intended for parts or repair."
};


export default function ConditionNoteTemplates({ setFormData, formData }) {
  return (
    <div className="mb-2">
      <Button
        variant="outline-primary"
        size="sm"
        className="me-2"
        onClick={() => setFormData({ ...formData, condition_notes: conditionTemplates.new })}
      >
        New
      </Button>
      <Button
        variant="outline-secondary"
        size="sm"
        className="me-2"
        onClick={() => setFormData({ ...formData, condition_notes: conditionTemplates.newWithTags })}
      >
        New w/ Tags
      </Button>
      <Button
        variant="outline-warning"
        size="sm"
        className="me-2"
        onClick={() => setFormData({ ...formData, condition_notes: conditionTemplates.used })}
      >
        Used
      </Button>
      <Button
        variant="outline-danger"
        size="sm"
        onClick={() => setFormData({ ...formData, condition_notes: conditionTemplates.forParts })}
      >
        For Parts
      </Button>
    </div>
  );
}
